import { render, staticRenderFns } from "./backToList.vue?vue&type=template&id=e1a1d1ec&"
import script from "./backToList.vue?vue&type=script&lang=js&"
export * from "./backToList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports